import React from 'react';
import { Pagination } from 'react-bootstrap';

export default function FiterPagination(props) {
  const { pages, page, setPage } = props;

  return (
    <Pagination>
      {pages > 1 ? (
        <Pagination.Prev
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        />
      ) : (
        <></>
      )}
      <Pagination.Item active={page === 1} onClick={() => setPage(1)}>
        1
      </Pagination.Item>

      {pages > 2 && page !== 1 && page !== pages ? (
        <>
          {page !== 1 ? <Pagination.Ellipsis disabled /> : <></>}
          <Pagination.Item active>{page}</Pagination.Item>
          {page !== pages - 2 ? <Pagination.Ellipsis disabled /> : <></>}
        </>
      ) : (
        <Pagination.Ellipsis disabled />
      )}

      {pages > 1 ? (
        <>
          <Pagination.Item
            active={page === pages}
            onClick={() => setPage(pages)}
          >
            {pages}
          </Pagination.Item>
          <Pagination.Next
            disabled={page === pages}
            onClick={() => setPage(page + 1)}
          />
        </>
      ) : (
        <></>
      )}
    </Pagination>
  );
}
